import createIcon from '../../createIcon';

/**
 * @component @name HolidayVillage
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOCA0TDIgMTBWMjBIMTRWMTBMOCA0Wk0xMiAxOEg5VjE1SDdWMThINFYxMC44M0w4IDYuODNMMTIgMTAuODNWMThaTTkgMTNIN1YxMUg5VjEzWk0xOCAyMFY4LjM1TDEzLjY1IDRIMTAuODJMMTYgOS4xOFYyMEgxOFpNMjIgMjBWNi42OUwxOS4zMSA0SDE2LjQ4TDIwIDcuNTJWMjBIMjJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const HolidayVillage = createIcon('HolidayVillage', [
  [
    'path',
    {
      d: 'M8 4L2 10V20H14V10L8 4ZM12 18H9V15H7V18H4V10.83L8 6.83L12 10.83V18ZM9 13H7V11H9V13ZM18 20V8.35L13.65 4H10.82L16 9.18V20H18ZM22 20V6.69L19.31 4H16.48L20 7.52V20H22Z',
      key: '14l1t3',
    },
  ],
]);

export default HolidayVillage;
